import { render } from "./EntityTagChip.vue?vue&type=template&id=d890c210"
import script from "./EntityTagChip.vue?vue&type=script&lang=js"
export * from "./EntityTagChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__